import { render } from "./AppButton.vue?vue&type=template&id=60db504d&bindings={\"isLoading\":\"props\"}"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"
script.render = render

export default script